export default "__VITE_ASSET__D1NTU70k__"